/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdateLanguagesRequestSelectedLanguagesInner } from './';
import {
    UpdateLanguagesRequestSelectedLanguagesInnerFromJSON,
    UpdateLanguagesRequestSelectedLanguagesInnerFromJSONTyped,
    UpdateLanguagesRequestSelectedLanguagesInnerToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateLanguagesRequest
 */
export interface UpdateLanguagesRequest {
    /**
     * 
     * @type {Array<UpdateLanguagesRequestSelectedLanguagesInner>}
     * @memberof UpdateLanguagesRequest
     */
    selectedLanguages: Array<UpdateLanguagesRequestSelectedLanguagesInner>;
}

/**
 * Check if a given object implements the UpdateLanguagesRequest interface.
 */
export function instanceOfUpdateLanguagesRequest(value: object): value is UpdateLanguagesRequest {
    if (!('selectedLanguages' in value) || value['selectedLanguages'] === undefined) return false;
    return true;
}

export function UpdateLanguagesRequestFromJSON(json: any): UpdateLanguagesRequest {
    return UpdateLanguagesRequestFromJSONTyped(json, false);
}

export function UpdateLanguagesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLanguagesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'selectedLanguages': ((json['selectedLanguages'] as Array<any>).map(UpdateLanguagesRequestSelectedLanguagesInnerFromJSON)),
    };
}

export function UpdateLanguagesRequestToJSON(value?: UpdateLanguagesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'selectedLanguages': ((value['selectedLanguages'] as Array<any>).map((v) => UpdateLanguagesRequestSelectedLanguagesInnerToJSON(v))),
    };
}

